import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  name() {
    return faker.lorem.sentence();
  },

  artist() {
    return faker.name.fullName();
  },

  url() {
    return faker.internet.url();
  },
});
